import { InjectionToken } from '@angular/core';

export const MediaDevicesToken = new InjectionToken<MediaDevices>(
  'MediaDevices'
);

export function mediaDevicesProvider(): MediaDevices {
  return navigator.mediaDevices;
}
